import React, { useState } from 'react';
import { Icon } from '../../Icon';
import { parseBrazilianNumber } from '../../../utils/formatUtils';
import { FormField, ResultCard, EducationalBlock } from '../finance/shared';

const ProportionalVacationCalculator = ({ onResultChange }: { onResultChange: (data: { label: string, value: string }[]) => void }) => {
  const [salary, setSalary] = useState('5.000,00');
  const [monthsWorked, setMonthsWorked] = useState('6');
  const [resultState, setResultState] = useState<any>(null);

  const calculate = () => {
    const s = parseFloat(parseBrazilianNumber(salary)) || 0;
    const m = parseInt(monthsWorked) || 0;
    if (s <= 0 || m <= 0) return;

    const days = (m / 12) * 30;
    const vacation = (s / 30) * days;
    const third = vacation / 3;
    const total = vacation + third;
    const res = { salary: s, months: m, days, vacation, third, total };
    setResultState(res);

    onResultChange([
      { label: 'Salário', value: `R$ ${s.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}` },
      { label: 'Meses Trabalhados', value: m.toString() },
      { label: 'Férias Proporcionais', value: `R$ ${vacation.toLocaleString('pt-BR', { minimumFractionDigits: 2 })} (${days.toFixed(1)} dias)` },
      { label: 'Terço Constitucional', value: `R$ ${third.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}` },
      { label: 'Total Bruto', value: `R$ ${total.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}` }
    ]);
  };

  return (
    <div className="space-y-8">
      <div className="bg-theme-result p-8 rounded-3xl shadow-lg border border-theme-border">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
          <FormField label="Salário (R$)" value={salary} onChange={setSalary} required isNumeric type="text" />
          <FormField label="Meses Trabalhados" value={monthsWorked} onChange={setMonthsWorked} required isInteger type="text" min={1} max={12} step="1" />
        </div>

        <div className="flex justify-center mb-8">
          <button
            onClick={calculate}
            className="px-12 py-4 bg-accent-gradient text-white rounded-xl font-bold hover:shadow-accent-hover hover:scale-[1.02] transition-all flex items-center justify-center gap-2"
          >
            <Icon name="play" className="w-5 h-5" />
            Calcular Férias
          </button>
        </div>

        {resultState && (
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <ResultCard title="Dias Proporcionais" value={`${resultState.days.toFixed(1)} dias`} color="blue" />
            <ResultCard title="Terço" value={`R$ ${resultState.third.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}`} color="amber" />
            <ResultCard title="Total" value={`R$ ${resultState.total.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}`} color="indigo" />
          </div>
        )}
      </div>

      <EducationalBlock
        title="Regras das Férias Proporcionais"
        tips={[
          'O trabalhador adquire 30 dias de férias a cada 12 meses trabalhados',
          'Férias proporcionais = (Salário / 12) × meses trabalhados',
          'O Terço Constitucional (1/3) é garantido por lei sobre o valor das férias',
          'Faltas injustificadas podem reduzir o número de dias de férias'
        ]}
      />
    </div>
  );
};

export default ProportionalVacationCalculator;
